export default __webpack_public_path__ + "static/media/7_1_3.57efe893.png";